import React from 'react';

export default () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='16'
    height='16'
    viewBox='0 0 16 16'
  >
    <path d='M8 1.146A6.862 6.862 0 0 1 14.854 8 6.854 6.854 0 1 1 8 1.146zm0 1.458a5.396 5.396 0 1 0 0 10.792A5.396 5.396 0 0 0 8 2.604zm3.34 4.667a.73.73 0 0 1 0 1.458H4.66a.73.73 0 0 1 0-1.458z' />
  </svg>
);
